import React, { Component } from "react";
import { MDBBtn, MDBModalBody, MDBModalHeader, MDBRow, MDBCol } from "mdbreact";
import { withTranslation } from "react-i18next";

class AddPMSProfile extends Component {
    constructor(props) {
        super(props);
        // If modifying, use selected profile data, otherwise use defaults
        const isModifying = this.props.isModifying;
        const selectedProfile = this.props.selectedProfile;
        
        this.state = {
            // Common fields
            profileName: isModifying && selectedProfile ? selectedProfile.ProfileName || "" : "",
            type: isModifying && selectedProfile ? selectedProfile.Type || "RealPage" : "RealPage",

            // RealPage specific fields
            realPageURL: isModifying && selectedProfile ?
                (selectedProfile.RealPageURL || "") :
                (this.props.realPage ? this.props.realPage["RealPageURL"] || "" : ""),
            // NETWORKUI-751: never pre-fill the API key into state/DOM — the field always
            // starts blank. A blank key on save means "keep the stored key" (see submitAddPMSProfile).
            realPageAPIKey: "",
            hasStoredRealPageAPIKey: isModifying && selectedProfile ?
                !!selectedProfile.RealPageAPIKey :
                !!(this.props.realPage && this.props.realPage["RealPageAPIKey"]),
            realPagePMCId: isModifying && selectedProfile ?
                (selectedProfile.RealPagePMCId || "") :
                (this.props.realPage ? this.props.realPage["RealPagePMCId"] || "" : ""),

            // Entrata specific fields
            entrataSubdomain: isModifying && selectedProfile ?
                (selectedProfile.EntrataSubdomain || "") : "",
            // NETWORKUI-751: never pre-fill the API key into state/DOM — see note above.
            entrataAPIKey: "",
            hasStoredEntrataAPIKey: isModifying && selectedProfile ?
                !!selectedProfile.EntrataAPIKey : false,

            // Common fields
            enableSync: isModifying && selectedProfile ?
                (selectedProfile.enableSync !== undefined ? selectedProfile.enableSync : true) : true,
        };
    }

    componentDidUpdate(prevProps) {
        // Update state when switching between add and modify modes
        if (prevProps.isModifying !== this.props.isModifying || 
            prevProps.selectedProfile !== this.props.selectedProfile) {
            
            const isModifying = this.props.isModifying;
            const selectedProfile = this.props.selectedProfile;
            
            this.setState({
                // Common fields
                profileName: isModifying && selectedProfile ? selectedProfile.ProfileName || "" : "",
                type: isModifying && selectedProfile ? selectedProfile.Type || "RealPage" : "RealPage",

                // RealPage specific fields
                realPageURL: isModifying && selectedProfile ?
                    (selectedProfile.RealPageURL || "") :
                    (this.props.realPage ? this.props.realPage["RealPageURL"] || "" : ""),
                // NETWORKUI-751: never pre-fill the API key into state/DOM — see constructor note.
                realPageAPIKey: "",
                hasStoredRealPageAPIKey: isModifying && selectedProfile ?
                    !!selectedProfile.RealPageAPIKey :
                    !!(this.props.realPage && this.props.realPage["RealPageAPIKey"]),
                realPagePMCId: isModifying && selectedProfile ?
                    (selectedProfile.RealPagePMCId || "") :
                    (this.props.realPage ? this.props.realPage["RealPagePMCId"] || "" : ""),

                // Entrata specific fields
                entrataSubdomain: isModifying && selectedProfile ?
                    (selectedProfile.EntrataSubdomain || "") : "",
                // NETWORKUI-751: never pre-fill the API key into state/DOM — see constructor note.
                entrataAPIKey: "",
                hasStoredEntrataAPIKey: isModifying && selectedProfile ?
                    !!selectedProfile.EntrataAPIKey : false,

                // Common fields
                enableSync: isModifying && selectedProfile ?
                    (selectedProfile.enableSync !== undefined ? selectedProfile.enableSync : true) : true,
            });
        }
    }
    
    submitAddPMSProfile = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        
        // Validate required fields based on PMS type
        const isValid = this.validateForm();
        
        if (isValid) {
            const profileData = {
                profileName: this.state.profileName,
                type: this.state.type,
            };
            
            if (this.state.type === "RealPage") {
                profileData.realPageURL = this.state.realPageURL;
                profileData.realPagePMCId = this.state.realPagePMCId;
                // NETWORKUI-751: only include the key if the admin actually typed a new one.
                // Omitting it (rather than sending "") tells the backend to keep the stored key.
                if (this.state.realPageAPIKey) {
                    profileData.realPageAPIKey = this.state.realPageAPIKey;
                }
            } else if (this.state.type === "Entrata") {
                profileData.entrataSubdomain = this.state.entrataSubdomain;
                if (this.state.entrataAPIKey) {
                    profileData.entrataAPIKey = this.state.entrataAPIKey;
                }
            }
            
            profileData.enableSync = this.state.enableSync;
            
            this.props.submitAddPMSProfile(profileData);
        }
    };
    
    validateForm = () => {
        if (!this.state.profileName) return false;

        if (this.state.type === "RealPage") {
            const hasKey = this.state.realPageAPIKey || this.state.hasStoredRealPageAPIKey;
            return this.state.realPageURL && hasKey && this.state.realPagePMCId;
        } else if (this.state.type === "Entrata") {
            const hasKey = this.state.entrataAPIKey || this.state.hasStoredEntrataAPIKey;
            return this.state.entrataSubdomain && hasKey;
        }

        return false;
    };
    
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    changeCheckbox = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };
    
    changePMSType = (event) => {
        this.setState({ 
            type: event.target.value,
        });
    };
    
    render() {
        const { t } = this.props;
        const isRealPage = this.state.type === "RealPage";
        const isEntrata = this.state.type === "Entrata";
        
        return (
            <>
                <MDBModalHeader toggle={this.props.toggleAddPMSProfile}>
                    <h4>{this.props.isModifying ? "Modify PMS Profile" : "Add PMS Profile"}</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitAddPMSProfile}
                        noValidate
                    >
                        {/* Profile Name */}
                        <MDBRow>
                            <MDBCol col="12">
                                <label
                                    htmlFor="profileName"
                                    className="black-text"
                                >
                                    Profile Name*
                                </label>
                                <input
                                    required
                                    id="profileName"
                                    name="profileName"
                                    className="form-control"
                                    placeholder="Enter a descriptive name for this PMS profile"
                                    onChange={this.changeHandler}
                                    value={this.state.profileName}
                                />
                                <div className="invalid-feedback">
                                    Please provide a profile name.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        
                        {/* PMS Type Selection */}
                        <MDBRow>
                            <MDBCol col="12">
                                <label
                                    htmlFor="type"
                                    className="black-text"
                                >
                                    Type*
                                </label>
                                <select
                                    required
                                    id="type"
                                    name="type"
                                    className="form-control"
                                    onChange={this.changePMSType}
                                    value={this.state.type}
                                    disabled={this.props.isModifying} // Disable during edit
                                >
                                    <option value="RealPage">RealPage</option>
                                    <option value="Entrata">Entrata</option>
                                </select>
                                <div className="invalid-feedback">
                                    Please select a PMS type.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        {/* RealPage Specific Fields */}
                        {isRealPage && (
                            <>
                                <MDBRow>
                                    <MDBCol col="12">
                                        <label
                                            htmlFor="realPageURL"
                                            className="black-text"
                                        >
                                            RealPage URL*
                                        </label>
                                        <input
                                            required
                                            id="realPageURL"
                                            name="realPageURL"
                                            className="form-control"
                                            placeholder="https://api.realpage.com/..."
                                            onChange={this.changeHandler}
                                            value={this.state.realPageURL}
                                        />
                                        <small className="form-text text-muted">
                                            The base URL for your RealPage API endpoint
                                        </small>
                                        <div className="invalid-feedback">
                                            Please provide a valid RealPage URL.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="12">
                                        <label
                                            htmlFor="realPageAPIKey"
                                            className="black-text"
                                        >
                                            RealPage API Key{this.state.hasStoredRealPageAPIKey ? "" : "*"}
                                        </label>
                                        <input
                                            required={!this.state.hasStoredRealPageAPIKey}
                                            type="text"
                                            id="realPageAPIKey"
                                            name="realPageAPIKey"
                                            className="form-control"
                                            placeholder={
                                                this.state.hasStoredRealPageAPIKey
                                                    ? "•••••••••••• (key on file)"
                                                    : "Enter RealPage API Key"
                                            }
                                            autoComplete="new-password"
                                            onChange={this.changeHandler}
                                            value={this.state.realPageAPIKey}
                                        />
                                        <small className="form-text text-muted">
                                            {this.state.hasStoredRealPageAPIKey
                                                ? "A key is already on file. Leave blank to keep it, or enter a new key to replace it."
                                                : "Your API key for authenticating with RealPage services"}
                                        </small>
                                        <div className="invalid-feedback">
                                            Please provide a valid RealPage API Key.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="12">
                                        <label
                                            htmlFor="realPagePMCId"
                                            className="black-text"
                                        >
                                            RealPage PMC ID*
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            id="realPagePMCId"
                                            name="realPagePMCId"
                                            className="form-control"
                                            placeholder="Enter RealPage PMC ID"
                                            onChange={this.changeHandler}
                                            value={this.state.realPagePMCId}
                                        />
                                        <small className="form-text text-muted">
                                            Your Property Management Company ID in RealPage
                                        </small>
                                        <div className="invalid-feedback">
                                            Please provide a valid RealPage PMC ID.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </>
                        )}

                        {/* Entrata Specific Fields */}
                        {isEntrata && (
                            <>
                                <MDBRow>
                                    <MDBCol col="12">
                                        <label
                                            htmlFor="entrataSubdomain"
                                            className="black-text"
                                        >
                                            Entrata Subdomain*
                                        </label>
                                        <input
                                            required
                                            id="entrataSubdomain"
                                            name="entrataSubdomain"
                                            className="form-control"
                                            placeholder="your-property"
                                            onChange={this.changeHandler}
                                            value={this.state.entrataSubdomain}
                                        />
                                        <small className="form-text text-muted">
                                            The subdomain from your Entrata URL (e.g., "your-property" from your-property.entrata.com)
                                        </small>
                                        <div className="invalid-feedback">
                                            Please provide Entrata subdomain.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="12">
                                        <label
                                            htmlFor="entrataAPIKey"
                                            className="black-text"
                                        >
                                            Entrata API Key{this.state.hasStoredEntrataAPIKey ? "" : "*"}
                                        </label>
                                        <input
                                            required={!this.state.hasStoredEntrataAPIKey}
                                            type="text"
                                            id="entrataAPIKey"
                                            name="entrataAPIKey"
                                            className="form-control"
                                            placeholder={
                                                this.state.hasStoredEntrataAPIKey
                                                    ? "•••••••••••• (key on file)"
                                                    : "Enter Entrata API Key"
                                            }
                                            autoComplete="new-password"
                                            onChange={this.changeHandler}
                                            value={this.state.entrataAPIKey}
                                        />
                                        <small className="form-text text-muted">
                                            {this.state.hasStoredEntrataAPIKey
                                                ? "A key is already on file. Leave blank to keep it, or enter a new key to replace it."
                                                : "Your API key for authenticating with Entrata services"}
                                        </small>
                                        <div className="invalid-feedback">
                                            Please provide a valid Entrata API Key.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </>
                        )}

                        {/* Enable Sync */}
                        <MDBRow>
                            <MDBCol col="12">
                                <div className="form-check mt-3">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="enableSync"
                                        name="enableSync"
                                        onChange={this.changeCheckbox}
                                        checked={this.state.enableSync}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="enableSync"
                                    >
                                        Enable
                                    </label>
                                    {/* <small className="form-text text-muted">
                                        Enable/Disable Subscriber Sync of all Venues using this PMS profile.
                                    </small> */}
                                </div>
                            </MDBCol>
                        </MDBRow>

                        {/* Submit Buttons */}
                        <div className="text-right submitButton mt-4">
                            <MDBBtn color="danger" type="submit" disabled={this.props.add_pms_profile}>
                                {this.props.add_pms_profile === true ? (
                                    <>
                                        <div
                                            className="spinner-border spinner-border-sm mr-2"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                        {this.props.isModifying ? "Updating..." : "Adding..."}
                                    </>
                                ) : (
                                    this.props.isModifying ? "Update PMS Profile" : "Add PMS Profile"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.props.toggleAddPMSProfile}
                            >
                                Cancel
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(AddPMSProfile);
